import React from 'react';

import PDFViewer from 'pdf-viewer-reactjs';

const link =
  'https://fh.filgolf.com/files/ele/0_Forest_Hills_Golf_and_Country_Club_Inc_Definitive_Information_Statement_2May2024.pdf';

export default function E00() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>
          0. Forest Hills Golf and Country Club Inc. Definitive Information
          Statement 2May2024
        </strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
